import { LossLimitsType } from "app/types/userType";
import { api, apiAMS } from "../helpers/apiHelperV3";
import { urls } from "./urls";

const API_LOSS_LIMITS = urls.accounts.API_LOSS_LIMITS();
const API_UPDATE_LOSS_LIMITS_PROMPT =
  urls.public.API_REGISTRATION_UPDATE_LOSS_LIMITS_PROMPT();

/**
 * Fetch loss limits for currently logged in user
 */
export const fetchLossLimits = () => {
  const url = API_LOSS_LIMITS;
  return api
    .get(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Update loss limits for currently logged in user
 */
export const updateLossLimits = (limits: LossLimitsType) => {
  const url = API_LOSS_LIMITS;
  return api
    .put(url, limits)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Update loss limits for currently logged in user
 */
export const updateLossLimitsPrompt = (username: string) => {
  const url = API_UPDATE_LOSS_LIMITS_PROMPT;

  return apiAMS
    .put(url, {
      prompted: false,
      nickname: username,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Create loss limits for currently logged in user
 */
export const createLossLimits = (limits: LossLimitsType) => {
  const url = API_LOSS_LIMITS;
  return api
    .post(url, limits)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Decrease limits for currently logged in user
 */
export const decreaseLossLimit = (limits: LossLimitsType): any => {
  const url = `${API_LOSS_LIMITS}/decreaseRequest`;

  return api
    .post(url, limits)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Increase limits for currently logged in user
 */
export const increaseLossLimitRequest = (limits: LossLimitsType): any => {
  const url = `${API_LOSS_LIMITS}/increaseRequest`;

  return api
    .post(url, limits)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      console.log("error: ", error);
      throw error;
    });
};
/**
 * Remove limits for currently logged in user
 */
export const requestLossLimitRemoval = (limits: LossLimitsType): any => {
  const url = `${API_LOSS_LIMITS}/removalRequest`;

  return api
    .post(url, limits)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
